import { ViewClaimResults } from 'all-in-one-shared-api';
import { Modal } from 'antd';
import { CardTitle } from 'components/claimCard/CardTitle';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PreviousClaimUtils } from '../../utils/previousClaimUtils';
import { PreviousClaimCard } from './PreviousClaimCard';
import { useState } from 'react';
import { CustomPagination } from 'components';

interface PreviousClaimModalProps {
  isOpen: boolean;
  previousClaims?: ViewClaimResults[];
  handleOnClose: () => void;
  handleOnPreviousClaimClick: (prevClaim: ViewClaimResults) => void;
  page: number;
  setPage: (page: number) => void;
  previousClaimsCount: number;
}

const ListWrapper = styled.div`
  display: grid;
  row-gap: 16px;
  margin-bottom: 16px;
`;

export const PreviousClaimModal = ({
  isOpen,
  previousClaims,
  handleOnClose,
  handleOnPreviousClaimClick,
  page,
  setPage,
  previousClaimsCount,
}: PreviousClaimModalProps) => {
  const { t, i18n } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState<number | undefined>(0);

  const handleOnClick = () => {
    if (!previousClaims || currentIndex === undefined) return;

    handleOnPreviousClaimClick(previousClaims[currentIndex]);
  };
  return (
    <Modal
      open={isOpen}
      title={<CardTitle title={t('newClaim.claimInfo.duplicatedClaimInfo.selectClaim')} />}
      onCancel={handleOnClose}
      onOk={handleOnClick}
      okText={t('common.ok')}
      cancelText={t('common.cancel')}
    >
      <ListWrapper>
        {previousClaims?.map((claim, i) => (
          <PreviousClaimCard
            key={i}
            {...PreviousClaimUtils.mapPreviousClaimToCard(claim, i18n.language)}
            index={i}
            handleOnClick={setCurrentIndex}
            isSelected={currentIndex === i}
          />
        ))}
      </ListWrapper>
      <CustomPagination
        current={page}
        total={previousClaimsCount}
        showSizeChanger={false}
        onChange={setPage}
        pageSize={3}
      />
    </Modal>
  );
};
